<template>
    <div>
        <table class="table table-responsive-md border border-gray overflow-auto">
            <thead>
                <tr class="bg-table-header">
                    <th>Payable</th>
                    <th>Start Date</th>
                    <th>Start Time</th>
                    <th>End Date</th>
                    <th>End Time</th>
                    <th>Units</th>
                    <th>Rate</th>
                    <th>Rate Type</th>
                    <th>Paid</th>
                    <th class="text-end">Actions</th>
                </tr>
            </thead>
            <tbody v-if="!hasPayrollDetails">
                <template v-if="payrollDetailsLoading">
                    <tr v-for="i of loadingCount" :key="i" class="table-loading">
                        <td v-for="i of columns" :key="i">
                            <span class="shimmer-loading"></span>
                        </td>
                    </tr>
                </template>
                <tr v-else class="table-error">
                    <td colspan="10">
                        <h3>Error</h3>
                        <h6>There was a problem while getting Payroll Task Shifts. Please try again.</h6>
                        <button class="btn btn-primary mb-3" @click="getPayrollDetails()">Try Again</button>
                        <p>
                            If the problem persists, click
                            <a href="https://help.axxessweb.com/openid/login/1" target="_blank">here</a> to report it.
                        </p>
                    </td>
                </tr>
            </tbody>
            <!--Empty Table-->
            <tbody v-if="hasPayrollDetails && payrollDetails.length == 0 && newDetail.length == 0">
                <TableEmpty :col-span="columns" :component="diagnoses" secondary-message="No Payroll Detail Found" />
            </tbody>
            <!--Existing Details-->
            <tbody v-if="hasPayrollDetails">
                <PayrollDetailsRow
                    v-for="detail of payrollDetails"
                    :detail="detail"
                    :id="id"
                    :snapshot-view="snapshotView"
                />
            </tbody>
            <!--New Details-->
            <tbody>
                <PayrollDetailsRow
                    v-for="(detail, index) in newDetail"
                    :detail="detail"
                    :is-add-requested="true"
                    :save-new-detail="saveNewDetail"
                    :show="newDetail.length > 0"
                    :cancel-save-new-detail="cancelSaveNewDetail"
                    :is-new-terminal="isNewTerminal"
                    :snapshot-view="snapshotView"
                />
            </tbody>
        </table>
    </div>
</template>

<script lang="ts" src="./PayrollDetailsTable.ts"></script>
